import "@/lib/tz";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import "@/index.css";
import App from "@/App";
import NexusTvGate from "@/components/NexusTvGate";
import LiveShare from "@/components/LiveShare";
import VerifyApp from "@/components/verify/VerifyApp";
import { PoweredByAVTech } from "@/components/PoweredByAVTech";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const p = window.location.pathname.replace(/\/$/, "");
const isEyeRoute = p === "/eye";
const isRemoteRoute = p === "/remote";
const tvScreen = p === "/tv/a" ? "tv-a" : p === "/tv/b" ? "tv-b" : p === "/tv/floor" ? "tv-floor" : p === "/tv" ? "tv-pick" : null;
const isTvRoute = isEyeRoute || isRemoteRoute || !!tvScreen || p === "/nexus" || p === "/command";
const isTrackRoute = p === "/track";
const isVerifyRoute = p === "/verify" || p.startsWith("/verify/");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <PoweredByAVTech />
      {isVerifyRoute ? (
        <VerifyApp />
      ) : isTrackRoute ? (
        <>
          <Toaster position="top-center" richColors />
          <LiveShare />
        </>
      ) : isTvRoute ? (
        <>
          <Toaster position="top-center" richColors />
          <NexusTvGate mode={isRemoteRoute ? "remote" : isEyeRoute ? "eye" : tvScreen || "tv"} />
        </>
      ) : (
        <App />
      )}
    </QueryClientProvider>
  </React.StrictMode>,
);
